import { Alert } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { useError } from '../../components/ErrorMessage';
import WebViewAppBar from '../../components/WebViewAppBar';
import HideChatWidget from '../../components/ZendeskChat/HideChatWidget';
import { webApiClient } from '../../lib/fi-api/apiUtils';
import { gqlTypes } from '../../types';
import EditCreditCardBillingInfo from '../Checkout/pages/Billing/EditCreditCardBillingInfo';
import styles from './UpdateBillingInfo.module.scss';
import IconAlert from '../../assets/images/icons/icon_alert.svg';
import { HideCookieConsentBanner } from '../../lib/oneTrust';

export function UpdateBillingInfoCreditCard() {
  const { t } = useTranslation();
  const { error, setError, clearError } = useError();
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  const accountCode = queryParameters.get('accountCode');
  const message = queryParameters.get('message');

  const onUpdate = useCallback(
    async (args: { input: gqlTypes.BillingAccountInput }) => {
      setSubmitting(true);
      try {
        await webApiClient.put('/api/ecommerce/billing-info', { ...args.input, accountCode });
      } catch (e) {
        setError(t('there_was_an_error_saving_your_info_recheck_and_try_again'));
        setSubmitting(false);
        return;
      }
      setSubmitting(false);
      console.log('Billing info updated');
      history.replace(AppPaths.BillingInfoUpdate.Confirmation, { message });
    },
    [accountCode, history, setError, message, t],
  );

  return (
    <div className={styles.container}>
      <div className={styles.desktopTopBar}></div>
      <WebViewAppBar className={styles.mobileOnly} title={t('update_payment_information')} />
      <div className={styles.content}>
        <h1 className={styles.desktopOnly}>{t('update_payment_information')}</h1>
        <div className={styles.section}>
          <EditCreditCardBillingInfo
            actionText={t('save')}
            updateBillingInfo={onUpdate}
            billingInfo={null}
            submitting={submitting}
            setError={setError}
            clearError={clearError}
            compactForm={true}
            outlineErrorFields={true}
          />
        </div>
      </div>
      <HideChatWidget />
      <HideCookieConsentBanner />
      {error && (
        <Alert
          style={{
            background: '#E0352A',
            color: '#FFFFFF',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '120%',
          }}
          className={styles.errorAlert}
          icon={<img className={styles.errorAlertIcon} src={IconAlert} alt="!" />}
          action={
            <div className={styles.errorAlertDismiss} onClick={() => clearError()}>
              {t('dismiss')}
            </div>
          }
        >
          {t('there_was_an_error_saving_your_info_recheck_and_try_again')}
        </Alert>
      )}
    </div>
  );
}
